 export * from './actions';
 export * from './getters';
 export * from './mutations';
 export * from './state';
 export * from './types';

 export const name = 'system';
